export default __webpack_public_path__ + "assets/instant-apps-what-is-new.png";